import { PropsWithChildren, use } from 'react';

import classNames from 'classnames';

import { RadioCardGroupContext } from '../RadioCardGroup/RadioCardGroupContext';

interface Props extends PropsWithChildren {
   value: string;
}

export const RadioCard = ({ value, children }: Props) => {
   const { value: selectedValue, onChange } = use(RadioCardGroupContext);

   const checked = value === selectedValue;

   const handleClick = () => {
      if (checked) return;
      onChange?.(value);
   };

   return (
      <button
         type="button"
         role="radio"
         aria-checked={checked}
         value={value}
         className={classNames('flex-1 p-component-layout-box-spacing-padding-sm rounded-brand-border-radius-inset border-[1px] outline-none', {
            'bg-theme-color-on-primary-subtle -outline-offset-2 outline-2 outline-theme-color-primary': checked,
            'border-theme-color-border hover:border-theme-color-primary': !checked
         })}
         tabIndex={-1}
         onClick={handleClick}
      >
         {children}
      </button>
   );
};
